import { BrandColorType } from '@common/styles';

import { createOverlayComp } from '../common/util/createOverlayComp';
import { renderAlert } from './alert';
import { renderConfirm } from './confirm';

export type DialogType = 'complete' | 'warning';
export interface DialogMessageObject {
  title?: string;
  message: string;
  ok?: string;
  cancel?: string;
  type?: DialogType;
  variant?: 'default' | 'primary' | 'second' | 'third';
  brandColor?: BrandColorType;
}
export type DialogMessage = string | DialogMessageObject;

export type AlertReturnValue = 'ok' | 'skip';
const alertDialog = createOverlayComp<AlertReturnValue, DialogMessage>(renderAlert);
export type ConfirmReturnValue = 'ok' | 'skip' | 'cancel';
const confirmDialog = createOverlayComp<ConfirmReturnValue, DialogMessage>(renderConfirm);

/**
 * 앱에서 사용 중인 bottom-sheet dialog와 인터페이스를 맞춤
 * https://github.com/croquiscom/zigzag-www/blob/master/packages/web2app/src/zpay/popup/dialog/index.ts
 */
export class Dialog {
  static alert(message: DialogMessage) {
    return alertDialog(message);
  }
  static confirm(message: DialogMessage) {
    return confirmDialog(message);
  }
}
